// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5078) return "static/chunks/profiler.46d64fc8df31f1f4.js";
	if (chunkId === 7538) return "static/chunks/recorder.c63836e64b1ec3a8.js";
	if (chunkId === 2550) return "static/chunks/2550.04bc96d2c72257db.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"138":"774c54a29673678d","1397":"3df979560a991e32","5042":"2678d14e56d03723","9036":"9f97748977eae4e3"}[chunkId] + ".js";
};